import { Component, OnInit } from "@angular/core";
import { take } from "rxjs/operators";
import { Store, select } from "@ngrx/store";
import { SpinnerService } from "../../../shared/services/spinner.service";
import { CopyHelpers } from "../../../shared/helpers/copy.helpers";
import { clientConfig } from "./../../../shared/constant/app.constant";
import { AppFlowService } from "./../../../shared/services/app-flow/app-flow.service";
import { NavButton } from "./../../../shared/components/navigation/next-button.component";
import {
  addItemToTechSupportAction,
  clearItemsFromTechSupportAction,
  fillTechSupportAction,
  removeItemFromTechSupportAction,
  updateItemFromTechSupportAction,
} from "./../../../store/actions/tech-support.actions";

@Component({
  selector: "app-tech-support",
  templateUrl: "./tech-support.component.html",
  styleUrls: ["./tech-support.component.scss"],
})
export class TechSupportComponent implements OnInit {
  returnOrder: any;
  orderData: any;
  techSupport: any;
  techSupportAssessment: any;
  currentAssessment: any;
  index = 0;
  nextButton: NavButton = {
    buttonText: "continueButton",
    cssClass: "next-btn",
    isDisable: true,
  };

  screenNav: NavButton = {
    buttonText: "Tech Support",
    cssClass: "back-btn",
    number: 1,
  };

  isError = false;
  assessmentInfo =
    "You have already answered to the tech assessment. If you want to update your choices please click on Restart Tech Support.";
  showAssessmentInfo = false;
  itemsToDisplay: Array<{
    itemNumber: string;
    itemName: string;
    itemQuantity: number;
    assessmentId: string;
    assessmentResult: string;
  }>;

  constructor(
    private spinnerService: SpinnerService,
    private appFlowService: AppFlowService,
    private store: Store<AppState>
  ) {
    const route = this.appFlowService.findRouteFromSequence("techsupport");
    if(clientConfig.APPFLOW === "formPostOrderB2CTechSupportFlow")
    {
      this.appFlowService.activeStepId = this.screenNav.number + 1;
    }
    else
    this.appFlowService.activeStepId = this.screenNav.number;
    this.nextButton.routeUrl = `/d/${route.next}`;
    this.screenNav.routeUrl = route.back ? `/d/${route.back}` : "";
    this.store.pipe(select("techSupport")).subscribe((items) => {
      this.techSupport = CopyHelpers.deepCopy(items);
    });

    this.store
      .pipe(select("orderData"))
      .pipe(take(1))
      .subscribe((o) => {
        this.orderData = o;
      });

    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
    });

    const orderLineAssessmentIds = this.returnOrder.items
      .filter((o) => o.returnable === true && o.assessmentId)
      .map((orderLine) => orderLine.assessmentId);
    this.techSupportAssessment = clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.filter((assessment) =>
      orderLineAssessmentIds.includes(assessment.assessmentId)
    );

    this.fillItemsToDisplay();

    if (this.techSupport && this.techSupport.items && this.techSupport.items.length !== 0) {
      this.showAssessmentInfo = true;
      this.nextButton.isDisable = false;
    } else {
      this.currentAssessment = this.techSupportAssessment[this.index];
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {}

  ngAfterViewInit() {
    if (this.showAssessmentInfo) this.displayRestartButton("block");
    else this.displayRestartButton("none");
  }

  fillItemsToDisplay() {
    this.itemsToDisplay = this.returnOrder.items
      .filter((o) => o.returnable === true)
      .map((orderLine) => {
        return {
          itemNumber: orderLine.itemNumber,
          itemName: orderLine.itemName,
          itemQuantity: orderLine.quantityToReturn,
          assessmentId: orderLine.assessmentId,
          assessmentResult:
            this.techSupportAssessment.findIndex((x) => x.assessmentId === orderLine.assessmentId) === -1
              ? "Return needed"
              : this.techSupport &&
                this.techSupport.items &&
                this.techSupport.items.length !== 0 &&
                this.techSupport.items.findIndex((x) => x.itemNumber === orderLine.itemNumber) !== -1
              ? this.techSupport.items.find((x) => x.itemNumber === orderLine.itemNumber).assessmentResult
              : "Pending",
        };
      });
  }

  onOptionSelection(selectedOption: any) {
    this.currentAssessment.answer = selectedOption;

    if (
      this.currentAssessment.nextSteps &&
      this.currentAssessment.nextSteps.length !== 0 &&
      !this.currentAssessment.nextSteps[selectedOption.optionId].assessmentResult
    ) {
      // store & display next question based on previous assessment result
      this.currentAssessment = this.currentAssessment.nextSteps[selectedOption.optionId];
    } else {
      // incremented index for accessing assessment for next item
      this.index++;

      // store assessment result for one item on top level of array by getting result from nested level
      const assessment = this.techSupportAssessment.find(
        (assessment) => assessment.assessmentId === this.currentAssessment.assessmentId
      );
      assessment.assessmentResult = this.currentAssessment.nextSteps[selectedOption.optionId].assessmentResult;

      // update UI of items table
      const item = this.itemsToDisplay.find((item) => item.assessmentId === this.currentAssessment.assessmentId);
      item.assessmentResult = this.currentAssessment.nextSteps[selectedOption.optionId].assessmentResult;

      if (this.techSupportAssessment[this.index] && Object.keys(this.techSupportAssessment[this.index]).length !== 0) {
        // if assessment exists for next item
        this.currentAssessment = this.techSupportAssessment[this.index];
      } else if (this.currentAssessment.nextSteps && this.currentAssessment.nextSteps.length !== 0) {
        // if no assessment exists for next item, reset
        this.currentAssessment = null;
        // store entire result for all items to ngrx store
        this.storeTechSupportResult();
        this.showAssessmentInfo = true;
        this.nextButton.isDisable = false;
        this.displayRestartButton("block");
      }
    }
  }

  storeTechSupportResult() {
    let items = [];
    if (this.techSupportAssessment && this.techSupportAssessment.length !== 0) {
      items = this.techSupportAssessment.map((assessment) => {
        return {
          itemNumber: this.returnOrder.items.find((x) => x.assessmentId === assessment.assessmentId).itemNumber,
          itemName: this.returnOrder.items.find((x) => x.assessmentId === assessment.assessmentId).itemName,
          assessmentId: assessment.assessmentId,
          assessmentResult: assessment.assessmentResult,
          itemQuantity: this.returnOrder.items.find((x) => x.assessmentId === assessment.assessmentId).quantityToReturn,
        };
      });
    }

    this.store.dispatch(
      fillTechSupportAction({
        payload: { items: items },
      })
    );
  }

  displayRestartButton(display: string) {
    const element = document.getElementById("restartBtn");
    if (element) element.style.display = display;
  }

  restartTechSupport() {
    this.techSupportAssessment.forEach((techSupportAssessment) => {
      this.clearTechSupportAssessment(techSupportAssessment);
    });
    this.clearItemsFromTechSupportStore();
    this.resetStatusForItemsToDisplay();

    this.nextButton.isDisable = true;
    this.displayRestartButton("none");
    this.showAssessmentInfo = false;

    this.index = 0;
    this.currentAssessment = this.techSupportAssessment[this.index];
  }

  clearTechSupportAssessment(techSupportAssessment: any) {
    if (techSupportAssessment.nextSteps && techSupportAssessment.nextSteps.length !== 0) {
      this.clearTechSupportResult(techSupportAssessment);

      techSupportAssessment.nextSteps.forEach((element) => {
        this.clearTechSupportAssessment(element);
      });
    }
  }

  clearTechSupportResult(techSupportAssessment: any) {
    techSupportAssessment.answer = null;
    techSupportAssessment.assessmentResult = null;
  }

  resetStatusForItemsToDisplay() {
    this.itemsToDisplay.forEach((item, index, array) => {
      if (this.techSupportAssessment.findIndex((x) => x.assessmentId === item.assessmentId) !== -1) {
        array[index].assessmentResult = "Pending";
      }
    });
  }

  // ngrx store action calls //
  addItemToTechSuportStore() {
    const item = {
      itemNumber: "5",
      itemName: "Printer",
      assessmentId: "W5",
      assessmentResult: "No return needed",
      itemQuantity: "3",
    };

    //const newItem = CopyHelpers.deepCopy(orderLine);

    this.store.dispatch(
      addItemToTechSupportAction({
        payload: { item: item },
      })
    );
  }

  removeItemFromTechSuportStore() {
    const item = {
      itemNumber: "4",
      itemName: "Radio",
      assessmentId: "W4",
      assessmentResult: "No return needed",
      itemQuantity: "2",
    };

    //const newItem = CopyHelpers.deepCopy(orderLine);

    this.store.dispatch(
      removeItemFromTechSupportAction({
        payload: { item: item },
      })
    );
  }

  updateItemFromTechSuportStore() {
    this.store.dispatch(
      updateItemFromTechSupportAction({
        payload: {
          item: { assessmentResult: "Return needed" },
          itemNumber: "2",
        },
      })
    );
  }

  clearItemsFromTechSupportStore() {
    this.store.dispatch(clearItemsFromTechSupportAction());
  }

  LogDataFromTechSupportStore() {
    this.store.pipe(select("techSupport")).subscribe((items) => {
      this.techSupport = CopyHelpers.deepCopy(items);
    });

    console.log("this.techSupport :>> ", this.techSupport);
  }

  getTableBorderColor(item: any) {
    if (item && this.currentAssessment && item.assessmentId === this.currentAssessment.assessmentId) {
      return true;
    }
  }
}
